import { observer } from 'mobx-react';
import React, { useEffect, useMemo } from 'react';
// @ts-ignore
import * as Validator from 'validatorjs';
import { toJS } from 'mobx';

import { Title3 } from '../Typography';
import TextInput from '../TextInput';
import { about } from './index';
import styles from './styles.module.scss';

const AccountEur = observer(() => {
  // Находим EUR банковские реквизиты
  const eurBank = about.values.bank_details.find(
    (item) => item.currency === 'EUR',
  );

  // Правила валидации для EUR счета
  const validationRules = {
    bank_name: 'required',
    swift: 'required|regex:/^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/',
    account: 'required',
  };

  const validation = useMemo(
    () =>
      new Validator(toJS(eurBank), validationRules, {
        required: 'This field is required',
        regex: 'Invalid SWIFT code format',
      }),
    [eurBank?.bank_name, eurBank?.swift, eurBank?.account],
  );

  const isValid = validation.passes();

  useEffect(() => {
    about.isStepIsValid[5] = isValid;
  }, [isValid]);

  // Если нет EUR банка, не показываем ничего
  if (!eurBank) {
    return null;
  }

  return (
    <>
      <div style={{ marginBottom: '20px' }}>
        <Title3 className={styles.subTitle}>Your EUR Bank Account</Title3>
      </div>

      <TextInput
        onChange={(e) => {
          eurBank.bank_name = e;
        }}
        label="Bank name*"
        dataTest="bankName"
        className={styles.textField}
        value={eurBank.bank_name || ''}
        error={validation.errors.first('bank_name')}
      />

      <TextInput
        onChange={(e) => {
          eurBank.swift = e;
        }}
        label="SWIFT code*"
        dataTest="swiftCode"
        className={styles.textField}
        value={eurBank.swift || ''}
        error={validation.errors.first('swift')}
      />

      <TextInput
        onChange={(e) => {
          eurBank.account = e;
        }}
        label="IBAN or account number*"
        dataTest="iban"
        className={styles.textField}
        value={eurBank.account || ''}
        error={validation.errors.first('account')}
      />

      <TextInput
        onChange={(e) => {
          eurBank.bank_address = e;
        }}
        label="Bank address"
        dataTest="bankAddress"
        className={styles.textField}
        value={eurBank.bank_address || ''}
      />
    </>
  );
});

export default AccountEur;
